import React, { useEffect, useRef, useState } from 'react';
import { debounce } from "lodash";
import { Typography } from "../../index";
import './badge.scss';

export const Badge = ({
    ariaLabel,
    count,
    children,
    colorStyle = 'default',
    disabled,
    text,
    show,
    size,
}) => {

    const countToDisplay = isNaN(parseInt(count, 10)) ? count : parseInt(count, 10) > parseInt('99', 10) ? '99+' : count;
    const badgeSize = size ? size : children ? 'small' : 'medium';
    const badgeContent = text ? text : count ? countToDisplay : '';

    const badgeRef = useRef();
    const [badgeContentWidth, setBadgeContentWidth] = useState();
    const getBadgeContentWidth = () => {
        return badgeRef?.current?.clientWidth ? badgeRef?.current?.clientWidth : '40';
    };

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setBadgeContentWidth(getBadgeContentWidth())
        }, 150);

        window.addEventListener('resize', debouncedHandleResize)

        return () => {
            window.removeEventListener('resize', debouncedHandleResize)
            debouncedHandleResize.cancel();
        }
    });

    useEffect(() => {
        setBadgeContentWidth(getBadgeContentWidth())
    }, [badgeRef]);

    const badgeClasses = [
        `bsw-badge`,
        `bsw-badge--${children ? 'primary' : 'inline'}`,
        `${badgeContentWidth < 40 ? 'bsw-badge-elem--small' : ''}`
    ].join(' ');

    const badgeLabelClasses = [
        `bsw-badge__label`,
        `bsw-badge-color--${colorStyle}`,
        `bsw-badge-size--${badgeContent === '' ? 'solid' : 'flexible'}-${badgeSize}`,
        `${disabled ? 'bsw-badge-disabled' : ''}`
    ].join(' ');

    const badgeLabel = show
        ? <div
            className={badgeLabelClasses}
            aria-label={ariaLabel}
        >
            <Typography
                type={badgeSize === "small" ? "meta-01" : "meta-02"}
                color={colorStyle === "subtle" ? "$color-primary-a2" : "$color-primary-c1"}
                >
                {badgeContent}
            </Typography>
        </div>
        : null;

    return (
        <div
            className={badgeClasses}
            ref={badgeRef}
        >
            {children}
            {badgeLabel}
        </div>
    )
}